import { IconButton, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import type { SelectMenuTriggerState } from 'src/components/SelectMenu';

const PlusButton = styled(IconButton)(({ theme }) => ({
  width: 28,
  height: 28,
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[2],
  '&:hover, &[aria-expanded="true"]': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.12),
  },
}));

/** The + that opens the step picker: on a connection, and at the end of a path. */
export const AddStepButton = ({
  getTriggerProps,
  label,
}: SelectMenuTriggerState & { label: string }) => (
  <PlusButton {...getTriggerProps()} className="nodrag nopan" size="small" aria-label={label}>
    <DynamicIcon name="add" sx={{ fontSize: 18 }} />
  </PlusButton>
);
